import { Box } from "@mui/material";
import { AppColor } from "../../../../types/Constants";
import { Link } from "react-router-dom";


const SubscribeBanner = () => {

    return (
        <Box sx={{
            width: "100%",
            backgroundColor: AppColor.orangeBackground,
            textAlign: "center",
            fontWeight: "600",
            padding: 1,
            borderRadius: 1
          }}
          >
            You are currently not subscribed. To subscribe and gain full access to Skidattl,&nbsp;
            <Link to="/subscriptions" style={{ textDecoration: "underline", cursor: "pointer", color: AppColor.baseOrange }}>click here</Link>

        </Box>
    );
};

export default SubscribeBanner;